import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
const defaultProps = {
  brandBaseUrl: null,
  partnerDesktopLogoComponent: null,
  partnerMobileLogoComponent: null
};
const Header = _ref => {
  let {
    desktopLogoComponent,
    mobileLogoComponent,
    partnerDesktopLogoComponent,
    partnerMobileLogoComponent,
    brandBaseUrl
  } = _ref;
  const desktopLogo = brandBaseUrl ? /*#__PURE__*/React.createElement("a", {
    href: brandBaseUrl
  }, desktopLogoComponent) : desktopLogoComponent;
  const mobileLogo = brandBaseUrl ? /*#__PURE__*/React.createElement("a", {
    href: brandBaseUrl
  }, mobileLogoComponent) : mobileLogoComponent;
  return /*#__PURE__*/React.createElement(Container, {
    fluid: true,
    className: "header-container"
  }, /*#__PURE__*/React.createElement(Row, {
    className: "align-items-center h-100"
  }, /*#__PURE__*/React.createElement(Col, {
    xs: 2,
    lg: {
      offset: 1,
      span: 2
    },
    className: "px-0 d-none d-lg-block",
    "data-testid": "desktop-logo"
  }, desktopLogo), /*#__PURE__*/React.createElement(Col, {
    xs: 2,
    className: "pr-0 d-block d-lg-none",
    "data-testid": "mobile-logo"
  }, mobileLogo), partnerDesktopLogoComponent && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Col, {
    xs: true,
    className: "d-none d-lg-block",
    "data-testid": "partner-logo"
  }, partnerDesktopLogoComponent), /*#__PURE__*/React.createElement(Col, {
    xs: true,
    lg: 2,
    className: "d-block d-lg-none",
    "data-testid": "partner-logo"
  }, partnerMobileLogoComponent))));
};
Header.defaultProps = defaultProps;
export { Header };